import { Clock, MapPin, Phone, Mail } from "lucide-react";
import { BUSINESS } from "@/lib/legal";

export const TopInfoBar = ({ collapsed }) => (
  <div
    data-testid="top-info-bar"
    className={`hidden sm:block bg-slate-900 text-slate-300 text-xs overflow-hidden transition-[height] duration-300 ${collapsed ? "h-0" : "h-8"}`}
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 h-8 flex items-center justify-between gap-4">
      <div className="flex items-center gap-5">
        <span className="flex items-center gap-1.5" data-testid="top-bar-hours">
          <Clock className="h-3.5 w-3.5 text-cyan-400" /> {BUSINESS.hours}
        </span>
        <span className="hidden md:flex items-center gap-1.5" data-testid="top-bar-address">
          <MapPin className="h-3.5 w-3.5 text-cyan-400" /> C. de María Zayas Sotomayor 18, Zaragoza
        </span>
      </div>
      <div className="flex items-center gap-5">
        <a href={`tel:${BUSINESS.phoneTel}`} data-testid="top-bar-phone"
          className="flex items-center gap-1.5 hover:text-white transition-colors">
          <Phone className="h-3.5 w-3.5 text-cyan-400" /> {BUSINESS.phone}
        </a>
        <a href={`mailto:${BUSINESS.email}`} data-testid="top-bar-email"
          className="hidden md:flex items-center gap-1.5 hover:text-white transition-colors">
          <Mail className="h-3.5 w-3.5 text-cyan-400" /> {BUSINESS.email}
        </a>
      </div>
    </div>
  </div>
);
